<script>
	export let data;

	if (data) {
		if (!data.newData) data.newData = [];
		if (!data.requests) data.requests = [];
		if (data.newData[data.field_name]) {
			data.requests = data.newData[data.field_name];
		}
	}
</script>

{#if data.name}
	<h3>{data.name}</h3>
{/if}

{#if data.requests}
	<div class="requests">
		<ul class="requests__list">
			{#each data.requests as _request}
				<li class="requests__item">
					<div class="requests__data-wrap">
						<!-- {#if _request.Resource == "iMedClinic" && _request.Action == "edit" && _request.Data[0].Resource == "iMedClinicService"}
							<span class="requests__premod-status"
								>Заявка на изменение цен на услуги клиники</span
							>
						{/if} -->
						{#if _request.Resource == "iMedClinic" && _request.Action == "add"}
							<span class="requests__premod-status"
								>Заявка на добавление клиники</span
							>
						{/if}
						{#if _request.Resource == "iMedDoctor" && _request.Action == "add"}
							<span class="requests__premod-status"
								>Заявка на добавление специалиста</span
							>
						{/if}
						{#if _request.Resource == "iMedClinicDoctor" && _request.Action == "edit"}
							<span class="requests__title"
								>Заявка на добавление специалиста к клинике</span
							>
						{/if}
						{#if _request.Data}
							{#each _request.Data as _data}
								{#if _data.DataValue}
									{#each _data.DataValue as _value}
										<div class="requests__data">
											<span class="requests__fieldname">
												{#if _value.FieldTitle}
													<b>{_value.FieldTitle}</b>
													{#if _value.auxFormatted && _value.auxFormatted.length == 1}
														<span
															>{_value
																.auxFormatted[0]}</span
														>
													{/if}
													{#if _value.auxFormatted && _value.auxFormatted["ServiceID"]}
														<span
															>{_value
																.auxFormatted[
																"ServiceID"
															]}</span
														>
													{/if}
												{/if}
											</span>
											<span class="requests__value new"
												>Стало: {@html _value.NewValueFormatted ==
												0
													? "удалено"
													: _value.NewValueFormatted}</span
											>
											<span class="requests__value old"
												>Было: {@html _value.OldValueFormatted}</span
											>
										</div>
									{/each}
								{/if}
							{/each}
						{/if}
					</div>
					<div class="requests__info">
						{#if _request.ID}
							<span class="requests__id">
								ID: {_request.ID}
							</span>
						{/if}
						{#if _request.StatusName}
							<span class="requests__status">
								Статус: {_request.StatusName}
								<i
									style="background-color: #{_request.Color};"
								/>
							</span>
						{/if}
						{#if _request.Created}
							<span class="requests__date"
								>Создана: {_request.Created}</span
							>
						{/if}
						{#if _request.ModifiedDate}
							<span class="requests__date"
								>Обработана: {_request.ModifiedDate}</span
							>
						{/if}
						{#if _request.ChangeStatusReason}
							<div class="requests__reason">
								<span>Причина отказа: </span>
								<span>{_request.ChangeStatusReason}</span>
							</div>
						{/if}
						{#if _request.Doctor}
							<div class="requests__clinic">
								<span>
									Специалист:
									{#if _request.Doctor.url}
										<a
											href={_request.Doctor.url}
											target="_blank"
										>
											{#if _request.Doctor.Name}
												{_request.Doctor.Name}
											{:else}
												{"Без имени"}
											{/if}
										</a>
									{:else}
										<span>
											{#if _request.Doctor.Name}
												{_request.Doctor.Name}
											{:else}
												{"Без имени"}
											{/if}
										</span>
									{/if}
								</span>
							</div>
						{/if}
						{#if _request.Clinic}
							<div class="requests__clinic">
								<span>
									Клиника:
									{#if _request.Clinic.url}
										<a
											href={_request.Clinic.url}
											target="”_blank”"
										>
											{#if _request.Clinic.Name}
												{_request.Clinic.Name}
											{:else if _request.Clinic.NameFull}
												{_request.Clinic.NameFull}
											{:else if _request.Clinic.ID == 0}
												{"Не существует"}
											{:else}
												{"Без названия"}
											{/if}
										</a>
									{:else}
										<span>
											{#if _request.Clinic.Name}
												{_request.Clinic.Name}
											{:else if _request.Clinic.NameFull}
												{_request.Clinic.NameFull}
											{:else if _request.Clinic.ID == 0}
												{"Не существует"}
											{:else}
												{"Без названия"}
											{/if}
										</span>
									{/if}
								</span>
								{#if _request.Clinic.Adress}
									<span class="requests__clinic-adress"
										>Адрес: {_request.Clinic.Adress}</span
									>
								{/if}
							</div>
						{/if}
					</div>
				</li>
			{/each}
		</ul>
	</div>
{/if}

<style lang="scss">
	.hidden {
		height: 0;
		width: 0;
		opacity: 0;
		pointer-events: none;
		z-index: -100;
		position: absolute;
	}
	.requests {
		display: flex;
		flex-direction: column;
		@media (min-width: 992px) {
			max-width: var(--module-width-1);
		}
		&__title {
			font-weight: bold;
			font-size: 18px;
			margin-bottom: 16px;
		}
		&__list {
			display: flex;
			flex-direction: column;
		}
		&__item {
			display: flex;
			margin-bottom: 30px;
			border: solid 1px var(--color-1);
			border-radius: 20px;
			padding: 20px;
			box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
			background-color: var(--bg-main-1);
			@media (max-width: 991px) {
				flex-direction: column-reverse;
			}
			&:last-child {
				margin-bottom: 0;
			}
		}
		&__info {
			display: flex;
			flex-wrap: wrap;
			flex-shrink: 0;
			@media (min-width: 992px) {
				width: 250px;
				flex-direction: column;
			}
			> span {
				padding: 0 10px 10px 0;
				white-space: nowrap;
			}
		}
		&__reason {
			display: flex;
			flex-direction: column;
		}
		&__status {
			display: flex;
			align-items: center;
			white-space: nowrap;
			> i {
				height: 16px;
				width: 16px;
				border-radius: 50%;
				display: flex;
				flex-shrink: 0;
				margin-left: 10px;
				border: solid 1px #2c303b2c;
			}
		}
		&__data {
			display: flex;
			flex-direction: column;
			padding: 10px 0 20px;
			&:first-child {
				padding-top: 0;
			}
			&:last-child {
				padding-bottom: 0;
			}

			&-wrap {
				display: flex;
				flex-direction: column;
				flex-grow: 1;
				@media (min-width: 992px) {
					margin-right: 16px;
				}
			}
		}
		&__fieldname {
			display: flex;
			flex-direction: column;
			> span {
				margin-top: 6px;
			}
		}
		&__value {
			display: flex;
			flex-direction: column;
			padding: 6px 0 6px 10px;
			word-break: break-word;
			&.old {
				color: gray;
			}
		}
		&__image {
			height: 40px;
			width: 40px;
			border-radius: 8px;
			flex-shrink: 0;
			overflow: hidden;
			display: flex;
			flex-direction: column;
			align-self: stretch;
			justify-content: space-evenly;
			margin: 0 16px 16px 0;
			> img {
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
			&.blank {
				padding: 15px;
			}
		}
		&__clinic {
			display: flex;
			flex-direction: column;
			> span {
				display: inline-block;
			}
			&-adress {
				margin-top: 10px;
			}
		}
	}
</style>
